export default {
  label: {
    title: 'Importar archivo',
    file: 'Archivo',
    insertFile: 'Seleccione el documento',
    link: 'Link de acceso al documento',
    cancel: 'Cancelar',
    ok: 'Ok',
    select: 'Seleccionar',
    send: 'Enviar',
    clear: 'Limpiar',
    date: 'Fecha del documento',
    checkbox: 'Mascarado',
    invalidLink: 'Link invalido',
    requiredValue: 'Valor obligatorio',
  },

  infoLabel: 'Información del formulario',
  closeLabel: 'Cerrar información',

  upload: {
    error: 'No conseguimos cargar el documento. Favor conferir los datos y intentar nuevamente. Caso persista, entre en contacto con el soporte',
    success: 'Documento cargado con éxito',
    duplicated: 'Este documento ya fue previamente insertado',
  },

  faq: {
    title: '¿Qué es?',
    description: 'Formulario utilizado para la importación de archivos en PDF para la lectura de los datos.',
  },
  faq2: {
    title: '¿Cómo utilizar?',
    description: 'Seleccione el archivo en su máquina en el primer campo. En el segundo campo inserte el enlace de acceso al archivo. En el tercer campo seleccione la fecha del documento. Por último, seleccione si el documento tiene información enmascarada.',
  },
  faq3: {
    title: '¿Cómo redefinir el formulario?',
    description: 'Para limpiar el formulario, haga clic en el botón limpiar. Cuando una importación se realiza con éxito, el formulario se redefine automáticamente.',
  },
  faq4: {
    title: '¿Qué sucede si la importación falla?',
    description: 'Si una importación falla, se mostrará un mensaje de error. Redefina el formulario, verifique la información e intente nuevamente.',
  },
  faq5: {
    title: '¿Cuánto tiempo demora la importación de un archivo?',
    description: 'Existe un tiempo de espera de 30 segundos para la inserción de los datos en la tabla.',
  },
  faq6: {
    title: '¿Puedo importar más de un archivo?',
    description: 'La importación puede comportar más de un archivo. Sin embargo, si un documento está dividido en más de un archivo, se registrará como dos documentos diferentes.',
  },
};
